const LoganIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="100%"
            height="100%"
            viewBox="0 0 70 80"
        >
            <defs />
            <g>
                <image
                    x="0"
                    y="0"
                    width="70"
                    height="80"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAADACAYAAACDO2h3AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9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"
                    preserveAspectRatio="none"
                />
            </g>
        </svg>
    );
};

export default LoganIcon;
